module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_vm._l((_vm.types), function(hType, t) {
    return _c('div', {
      key: t
    }, [_c('v-card', {
      staticClass: "mb-3 ma-1"
    }, [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v(_vm._s(hType))])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0"
    }, [_c('v-data-table', {
      staticClass: "elevation-0",
      attrs: {
        "headers": !_vm.$vuetify.breakpoint.smAndUp || t === 1 ? _vm.accHead : _vm.accHeadSm,
        "items": _vm.accs.filter(function (rec) { return rec.bc_acc_type === hType; }),
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(props.item.bc_acc_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && t === 0) ? _c('td', [_vm._v(_vm._s(props.item.bank_acc_type))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatCur(Math.abs(props.item.tot_debit_amount - props.item.tot_credit_amount))))])])]
        }
      }], null, true)
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-speed-dial', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "accent",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.prepareCreate('Bank')
      }
    }
  }, [_c('v-icon', [_vm._v("account_balance")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "indigo"
    },
    on: {
      "click": function($event) {
        return _vm.prepareCreate('Cash')
      }
    }
  }, [_c('v-icon', [_vm._v("money")])], 1)], 1)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + (_vm.lAcc.bc_acc_type ? ' ' + _vm.handy.startWithUpper(_vm.lAcc.bc_acc_type) : '')) + " Account\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Account name",
      "rules": [_vm.rules.required],
      "hint": _vm.lAcc.bc_acc_type === 'Bank' ? 'Eg:- ICICI Current A/C, SBI FD, etc...' : 'Eg:- Petty cash, Cash on hand, etc...',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.lAcc.bc_acc_name),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "bc_acc_name", $$v)
      },
      expression: "lAcc.bc_acc_name"
    }
  })], 1), _vm._v(" "), (_vm.lAcc.bc_acc_type === 'Bank') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "rules": [_vm.rules.required],
      "items": _vm.bankTypes
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lAcc.bank_acc_type),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "bank_acc_type", $$v)
      },
      expression: "lAcc.bank_acc_type"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-text', [(_vm.lAcc.no_tran_yet || _vm.sAction === 'update-balance') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.lAcc.no_tran_yet ? 'Opening balance' : 'New balance',
      "hide-details": "",
      "type": "number"
    },
    on: {
      "input": function($event) {
        return _vm.updateBal()
      }
    },
    model: {
      value: (_vm.lAcc.bc_acc_bal),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "bc_acc_bal", $$v)
      },
      expression: "lAcc.bc_acc_bal"
    }
  })], 1), _vm._v(" "), (_vm.sAction === 'update-balance') ? _c('v-flex', {
    staticClass: "mt-4 text-xs-center caption",
    staticStyle: {
      "border": "1px solid orange"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "subheading"
  }, [_vm._v("Difference:\n                              "), _c('span', {
    staticClass: "subheading info--text"
  }, [_vm._v(_vm._s(_vm.handy.formatCur(_vm.lAcc.bal_diff)))])])]) : _vm._e(), _vm._v(" "), (_vm.sAction === 'update-balance' && ((_vm.lAcc.bank_acc_type !== 'Loan' && _vm.lAcc.bal_diff > 0) || (_vm.lAcc.bank_acc_type === 'Loan' && _vm.lAcc.bal_diff < 0))) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Reason for difference",
      "rules": [_vm.rules.required],
      "items": _vm.incomeHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.lAcc.credit_gl_acc_id),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "credit_gl_acc_id", $$v)
      },
      expression: "lAcc.credit_gl_acc_id"
    }
  })], 1) : (_vm.sAction === 'update-balance' && _vm.lAcc.bal_diff !== 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Reason for difference'",
      "rules": [_vm.rules.required],
      "items": _vm.expHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.lAcc.debit_gl_acc_id),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "debit_gl_acc_id", $$v)
      },
      expression: "lAcc.debit_gl_acc_id"
    }
  })], 1) : _vm._e()], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Balance ")]), _vm._v(" "), _c('div', {
    staticClass: "title info--text"
  }, [_vm._v(_vm._s(_vm.handy.formatCur(_vm.lAcc.bc_acc_bal)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.sAction = 'update-balance'
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Min balance",
      "hide-details": "",
      "disabled": !_vm.lAcc.is_alert_min_bal
    },
    model: {
      value: (_vm.lAcc.min_bal),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "min_bal", $$v)
      },
      expression: "lAcc.min_bal"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-switch', {
    staticClass: "mt-3",
    attrs: {
      "label": _vm.$vuetify.breakpoint.smAndUp ? 'Min balance alert' : 'Alert',
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lAcc.is_alert_min_bal),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "is_alert_min_bal", $$v)
      },
      expression: "lAcc.is_alert_min_bal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAcc($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": _vm.beingSaved,
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9518cf48","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bank.vue
// module id = 848
// module chunks = 46